/**
 * A work item that is the Salesforce copy of a WHG Docs document review,
 * while that review is still someone's move. The server says so by
 * attaching the review itself (`reviewRow`, the Home row shape, with
 * `review.live`) — see review_copy on the backend.
 *
 * Matthew, 10/27: he opened the Kelly Fiers statement's copy on the
 * matter page and clicked Return; Salesforce moved, the review did not,
 * and his Home page kept the row 41 days overdue. One piece of work gets
 * one set of buttons: the copy shows the review's card (Approve / Send
 * back for rework; Done / Dismiss) and never Return / Close of its own,
 * and paper cannot be attached-and-returned to it. Once the review is
 * settled the copy is a leftover and keeps its own verbs so it can be
 * tidied away.
 */
export const isLiveReviewCopy = (item) =>
  Boolean(item?.reviewRow?.review?.live);
